var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCalendarCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.50049 4.84717H19.5005C20.053 4.84717 20.5005 5.29467 20.5005 5.84717V18.3472C20.5005 19.4509 19.6042 20.3472 18.5005 20.3472H5.50049C4.39674 20.3472 3.50049 19.4509 3.50049 18.3472V5.84717C3.50049 5.29467 3.94799 4.84717 4.50049 4.84717Z",
    fill: "#F2F2F3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5005 4.84717H4.50049C3.94799 4.84717 3.50049 5.29467 3.50049 5.84717V9.01217H20.5005V5.84717C20.5005 5.29467 20.053 4.84717 19.5005 4.84717Z",
    fill: "#B7B9BF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.28662 13.4901L11.6729 15.9976L15.4029 12.1201",
    stroke: "#EE464F",
    strokeWidth: 2.91667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.50049 3.65332C6.94799 3.65332 6.50049 4.10082 6.50049 4.65332V4.86957H8.50049V4.65332C8.50049 4.10082 8.05299 3.65332 7.50049 3.65332Z",
    fill: "#656A71"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5005 3.65332C15.948 3.65332 15.5005 4.10082 15.5005 4.65332V4.86957H17.5005V4.65332C17.5005 4.10082 17.053 3.65332 16.5005 3.65332Z",
    fill: "#656A71"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCalendarCheck);
export default __webpack_public_path__ + "static/media/icon_calendar_check.d5160475.svg";
export { ForwardRef as ReactComponent };